import React, {ChangeEvent, useRef, useState} from 'react';
import styles from './Search.module.scss';
import SearchIcon from '../../assets/icons/search.svg?react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isSingleRow?: boolean; // Add prop to indicate if in single row mode
};

function Search(props: Props) {
  const { onChange, value, placeholder } = props;
  const [focused, setFocused] = useState(false);
  const search = useRef(null);

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);
  const inFocus = () => {(search as any).current.focus()};
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  return (
    <div className={`${styles.wrapper} ${focused ? styles.focused : ''}`}>
      {!focused && (
        <div className={styles.searchWrapper}>
          <SearchIcon className={styles.searchIcon} onClick={inFocus}/>
        </div>
      )}
      <input ref={search} placeholder={placeholder ? placeholder : 'Search...'} onFocus={handleFocus} onBlur={handleBlur} className={styles.input} type="text" value={value} onChange={handleChange}/>
    </div>
  );
}

export default Search;
